import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OperationsService } from 'src/app/core/services/operations.service';
import { HelpersService } from '../../core/services/helpers.service';
import { BeniMobiliAdapter } from '../components/fascicolo/beni-mobili-view/beni-mobili-adapter';
import { BeneMobile } from '../models/bene-mobile/bene-mobile';
import { Comune } from '../models/tipologiche/comune';
import { Provincia } from '../models/tipologiche/provincia';
import { TipoDirittoReale } from '../models/tipologiche/tipo-diritto-reale';
import { TipoGenericoRimovibile } from '../models/tipologiche/tipo-generico-rimovibile';
import { FormValidationService } from '../services/form-validation.service';
import { NumericOperationManager } from '../utils/numeric-operation-manager';
import { BaseForm } from './base-Form';

export abstract class BeniMobiliFormComponent extends BaseForm {
  tipiBene: TipoGenericoRimovibile[] = [];
  tipoDirittoRealeOptions: TipoDirittoReale[] = [];
  provinceOptions: Provincia[] = [];
  cittaOptions: Comune[] = [];
  beneMobileRequest: BeneMobile;
  beniMobiliForm: FormGroup;

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected formValidationService: FormValidationService) {
    super();
  }

  populateSelect() {
    if (this.provinceOptions.length === 0) {
      this.helpers.getProvince().subscribe(response => this.provinceOptions = response);
    }

    if (this.getBeneMobile() && this.getBeneMobile().ubicazione && this.getBeneMobile().ubicazione.provincia && this.getBeneMobile().ubicazione.provincia.id) {
      this.helpers.getCittaByProvincia(this.getBeneMobile().ubicazione.provincia.id).subscribe(response => this.cittaOptions = response);
    }

    if (this.tipiBene.length === 0) {
      this.helpers.getTipiBeneMobile().subscribe(response => this.tipiBene = response);
    }

    if (this.tipoDirittoRealeOptions.length === 0) {
        this.helpers.getTipiDirittoReale().subscribe(response => this.tipoDirittoRealeOptions = response);
      }
  }


  createForm() {
    this.beneMobileRequest = BeniMobiliAdapter.createBeniMobiliRequest(this.getBeneMobile());
    this.beniMobiliForm = this.campiForm.group({
        tipoBene: [this.beneMobileRequest.tipoBeneMobile, Validators.required],
        valoreBene: [this.beneMobileRequest.valore],
        ipoteca: [this.beneMobileRequest.ipoteca],
        valoreIpoteca: [this.beneMobileRequest.valoreIpoteca],
        quantita: [this.beneMobileRequest.quantita],
        unitaMisura: [this.beneMobileRequest.unitaMisura],
        dataInventario: [this.beneMobileRequest.dataInventario],
        riferimentoInventario: [this.beneMobileRequest.riferimentoInventario],
        descrizioneBene: [this.beneMobileRequest.descrizione],
        via: [this.beneMobileRequest.ubicazione.via],
        civico: [this.beneMobileRequest.ubicazione.civico],
        cap: [this.beneMobileRequest.ubicazione.cap, Validators.compose([this.formValidationService.cap])],
        provincia: [this.beneMobileRequest.ubicazione.provincia],
        citta: [this.beneMobileRequest.ubicazione.localita],
        nazione: [this.beneMobileRequest.ubicazione.nazione],
        sommaBloccata: [this.beneMobileRequest.sommaBloccata],
        dataBloccoSomma: [this.beneMobileRequest.dataBloccoSomma],
        sommaSvincolata: [this.beneMobileRequest.sommaSvincolata],
        dataSvincoloSomma: [this.beneMobileRequest.dataSvincoloSomma],
        vendita: [this.beneMobileRequest.istanzaVendita.vendita],
        dataVendita: [this.beneMobileRequest.istanzaVendita.dataIstanza],
        acquirente: [this.beneMobileRequest.istanzaVendita.acquirente],
        ricavato: [this.beneMobileRequest.istanzaVendita.ricavato],
        assegnato: [this.beneMobileRequest.istanzaAssegnazione.assegnato],
        dataAssegnazione: [this.beneMobileRequest.istanzaAssegnazione.dataIstanza],
        note: [this.beneMobileRequest.note],
        quota: [this.beneMobileRequest.quota],
        tipoDirittoReale: [this.beneMobileRequest.tipoDirittoReale],
     });
  }

  changedIpoteca(newIpoteca: boolean) {
    this.beneMobileRequest.ipoteca = newIpoteca;
    if (!newIpoteca) {
      this.beneMobileRequest.valoreIpoteca = undefined;
    }
  }

  changedSommaBloccata(event) {
//    if (this.beneMobileRequest.sommaBloccata != newSommaBloccata) {
//      this.beneMobileRequest.sommaBloccata = newSommaBloccata;
//    }
      let newSommaBloccata = event.target.value;
    if (!newSommaBloccata || newSommaBloccata.length === 0) {
      this.beneMobileRequest.dataBloccoSomma = undefined;
    }
  }

  changedSommaSvincolata(event) {
//    if (this.beneMobileRequest.sommaSvincolata != newSommaSvincolata) {
//      this.beneMobileRequest.sommaSvincolata = newSommaSvincolata;
//    }
      let newSommaSvincolata = event.target.value;
    if (!newSommaSvincolata || newSommaSvincolata.length === 0) {
      this.beneMobileRequest.dataSvincoloSomma = undefined;
    }
  }

  changedProvincia(newProvincia: Provincia) {
    this.beneMobileRequest.ubicazione.provincia = newProvincia;
    this.beneMobileRequest.ubicazione.localita = null;
    this.cittaOptions = [];
    if (newProvincia) {
      this.helpers.getCittaByProvincia(newProvincia.id).subscribe(response => this.cittaOptions = response);
    }
  }

  changedVendita(newVendita: boolean) {
    this.beneMobileRequest.istanzaVendita.vendita = newVendita;
    if (!newVendita) {
      this.beneMobileRequest.istanzaVendita.acquirente = undefined;
      this.beneMobileRequest.istanzaVendita.dataIstanza = undefined;
      this.beneMobileRequest.istanzaVendita.ricavato = undefined;
    }
  }

  changedAssegnazione(newAssegnazione: boolean) {
    this.beneMobileRequest.istanzaAssegnazione.assegnato = newAssegnazione;
    if (!newAssegnazione) {
      this.beneMobileRequest.istanzaAssegnazione.dataIstanza = undefined;
    }
  }

  update() {
    this.getRequest(BeniMobiliAdapter.manageRequestForServer(this.beneMobileRequest));
  }

  getDiff(a: string, b: string) {
    return NumericOperationManager.getDiff(a, b);
  }

  abstract getBeneMobile(): BeneMobile;
  abstract getRequest(beneMobile: BeneMobile);
}
